import { motion } from "framer-motion";

const icons = {
  layers: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
      <path d="M12 2 2 7l10 5 10-5-10-5Z" strokeLinejoin="round" />
      <path d="m2 12 10 5 10-5" strokeLinejoin="round" />
      <path d="m2 17 10 5 10-5" strokeLinejoin="round" />
    </svg>
  ),
  trend: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
      <path d="M3 17 9 11l4 4 8-8" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M15 7h6v6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  export: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
      <path d="M12 3v12" strokeLinecap="round" />
      <path d="m7 8 5-5 5 5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M4 16v3a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-3" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  building: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
      <rect x="4" y="10" width="6" height="11" rx="1" />
      <rect x="14" y="4" width="6" height="17" rx="1" />
      <path d="M7 14h0M7 17h0M17 8h0M17 11h0M17 14h0M17 17h0" strokeLinecap="round" />
    </svg>
  ),
  sync: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
      <path d="M4 4v5h5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M20 20v-5h-5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M5.5 15a7 7 0 0 0 12.3 2.5M18.5 9A7 7 0 0 0 6.2 6.5" strokeLinecap="round" />
    </svg>
  ),
  shield: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
      <path d="M12 3 4 6v6c0 5 3.5 7.5 8 9 4.5-1.5 8-4 8-9V6l-8-3Z" strokeLinejoin="round" />
      <path d="m9 12 2 2 4-4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
};

function WhyQap() {
  const cards = [
    {
      icon: "layers",
      title: "True Consolidation",
      text: "Combine unlimited entities into a single, consistent view — no more stitching together fragile Excel workbooks by hand.",
    },
    {
      icon: "trend",
      title: "Instant MoM Insight",
      text: "Toggle month-over-month views to spot trends, variances, and anomalies across every company in seconds.",
    },
    {
      icon: "export",
      title: "Export & Audit Ready",
      text: "Generate clean, board-ready Excel exports formatted for auditors, lenders, and finance teams — no reformatting required.",
    },
    {
      icon: "building",
      title: "Multi-Entity, One Login",
      text: "Manage every company you oversee from a single dashboard, with grouping and reporting structures tailored to your org.",
    },
    {
      icon: "sync",
      title: "Live QuickBooks Sync",
      text: "Reports pull directly from QuickBooks Online, so your numbers stay current without manual imports or CSV wrangling.",
    },
    {
      icon: "shield",
      title: "Granular Line-Item Control",
      text: "Hide, restore, or drill into any single line item across companies — down to the transaction level — without losing your place.",
    },
  ];

  return (
    <section id="why" className="whyqap-section">
      <div className="whyqap-inner">
        <span className="section-eyebrow">Why QAP Financials</span>
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          Consolidated reporting, built right
        </motion.h2>

        <motion.p
          className="whyqap-subtitle"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ delay: 0.2 }}
          viewport={{ once: true }}
        >
          Built for CFOs, controllers, and finance teams who are done with
          broken spreadsheets and manual rollups.
        </motion.p>

        <div className="whyqap-grid">
          {cards.map((card, i) => (
            <motion.div
              key={card.title}
              className="whyqap-card"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.08, duration: 0.5 }}
              viewport={{ once: true, amount: 0.3 }}
              onMouseMove={(e) => {
                const rect = e.currentTarget.getBoundingClientRect();
                const x = e.clientX - rect.left;
                const y = e.clientY - rect.top;
                e.currentTarget.style.setProperty("--mouse-x", `${x}px`);
                e.currentTarget.style.setProperty("--mouse-y", `${y}px`);
              }}
            >
              <div className="whyqap-icon">{icons[card.icon]}</div>
              <h3>{card.title}</h3>
              <p>{card.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default WhyQap;
